import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { headerHeight, HeaderLink } from '@this/components/expenses/header/header';
import { ItemIcon, ReportIcon, ApprovalIcon, SettingIcon } from './header_icons';
import type User from '../../../domain/user/user';
import { styled } from '../../constants/themes';

interface Props {
  user: User;
  className?: string;
}

const NavContentSm: React.FC<Props> = ({ user, className }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <Nav className={className}>
      <HeaderLink>
        <Link to="/biztra/report_items">
          <ItemIcon isActive={path.startsWith('/biztra/report_items')} />
          <span className={path.startsWith('/biztra/report_items') ? 'active' : ''}>登録</span>
        </Link>
      </HeaderLink>
      <HeaderLink>
        <Link to="/biztra/reports">
          <ReportIcon isActive={path.startsWith('/biztra/reports')} />
          <span className={path.startsWith('/biztra/reports') ? 'active' : ''}>申請</span>
        </Link>
      </HeaderLink>
      {(user?.isOrganizationAdmin || user?.is_expenses_approver) && (
        <HeaderLink>
          <Link to="/biztra/approvals">
            <ApprovalIcon isActive={path.startsWith('/biztra/approvals')} />
            <span className={path.startsWith('/biztra/approvals') ? 'active' : ''}>承認</span>
          </Link>
        </HeaderLink>
      )}
      {user?.isOrganizationAdmin && (
        <HeaderLink>
          <Link to="/biztra/organization">
            <SettingIcon isActive={path.startsWith('/biztra/organization')} />
            <span className={path.startsWith('/biztra/organization') ? 'active' : ''}>管理</span>
          </Link>
        </HeaderLink>
      )}
    </Nav>
  );
};

const Nav = styled.nav`
  position: fixed;
  top: ${headerHeight};
  left: 0;
  right: 0;
  background-color: #393e46;
  z-index: 1000;
`;

export default NavContentSm;
